import { UploadUrl } from '@xeovision/storage-sdk';
import { DescribeProperty } from '../../common';
import { Model3dEntryResponse } from './model3d-entry.response';

export interface UploadListElement {
  fileName: string;
  key: string;
  urls: UploadUrl[];
}

export class Model3dCreateResponse {
  @DescribeProperty({
    description: 'The ID of created model3d entry',
    example: '123e4567-e89b-12d3-a456-426614174000',
  })
  model3dEntry: Model3dEntryResponse;

  @DescribeProperty({
    description: 'The list for upload objects',
    isArray: true,
  })
  uploadList: UploadListElement[];
}
